<div class="wall-result">
  <div class="wall-result__header">
    <span class="wall-result__count"
      >{{ walls().length }} {{ 'SEARCH_GLOBAL_MODAL.WALL_RESULT.WALLS' | translate }}</span
    >
    <div class="wall-result__header-actions">
      <button
        type="button"
        class="header-open-btn"
        [matTooltip]="'SEARCH_GLOBAL_MODAL.WALL_RESULT.CREATE_WALL' | translate"
        [disabled]="isCreating()"
        (click)="createWall()"
      >
        <span class="ui-icon-plus"></span>
      </button>
      <button
        type="button"
        class="header-open-btn"
        [matTooltip]="'SEARCH_GLOBAL_MODAL.WALL_RESULT.OPEN_WALLS' | translate"
        (click)="openWallsPage()"
      >
        <span class="ui-icon-new-tab"></span>
      </button>
    </div>
  </div>

  <div class="wall-result__filters">
    <ui-search
      class="wall-result__search"
      [placeholder]="'WALL_LIST.SEARCH_PLACEHOLDER' | translate"
      [searchQuery]="searchQuery()"
      (onInput)="onSearchQuery($event)"
    ></ui-search>

    <mat-select
      class="ui-selector wall-result__control wall-result__type-select"
      multiple
      [value]="selectedTypes()"
      [placeholder]="'COMMON.TYPE' | translate"
      (selectionChange)="onTypeChange($event)"
    >
      <mat-option [value]="false">{{ 'COMMON.PUBLIC' | translate }}</mat-option>
      <mat-option [value]="true">{{ 'COMMON.PRIVATE' | translate }}</mat-option>
    </mat-select>

    <ui-camera-select-button
      class="wall-result__control"
      [selectedCount]="selectedCameraList().length"
      (click)="openSelectCameraModal()"
    ></ui-camera-select-button>

    <app-tag-filter
      class="wall-result__control"
      [selectWidth]="'100%'"
      [formControl]="tagsFilterControl"
      [isCreateButtonVisibleSig]="false"
    ></app-tag-filter>
  </div>

  <div class="wall-result__chips" *ngIf="hasActiveFilters()">
    <ui-filter-chip
      *ngFor="let type of selectedTypes()"
      [title]="(type ? 'COMMON.PRIVATE' : 'COMMON.PUBLIC') | translate"
      (removeClicked)="onRemoveType(type)"
    ></ui-filter-chip>

    <ui-filter-chip
      *ngIf="searchQuery()"
      [title]="searchQuery()"
      (removeClicked)="onRemoveSearch()"
    ></ui-filter-chip>

    <ui-filter-chip
      *ngFor="let tagId of selectedTags()"
      [title]="tagEntities()[tagId]?.name"
      (removeClicked)="onRemoveTag(tagId)"
    ></ui-filter-chip>

    <ng-container *ngIf="selectedCameraList().length">
      <div [matMenuTriggerFor]="camerasMenu" class="wall-result__camera-chip">
        <ui-filter-chip
          [title]="selectedCameraList().length + ' ' + ('WALL_LIST.CAMERA_FILTER' | translate)"
          [allowDelete]="false"
        ></ui-filter-chip>
      </div>
      <mat-menu #camerasMenu="matMenu" xPosition="after" yPosition="below">
        <div class="wall-result__camera-menu">
          <ui-filter-chip
            *ngFor="let camera of selectedCameraList()"
            [title]="camerasEntities()[camera.cameraId]?.edgeOnly?.name"
            [allowDelete]="true"
            (removeClicked)="onRemoveCamera(camera.cameraId)"
          ></ui-filter-chip>
        </div>
      </mat-menu>
    </ng-container>
  </div>

  <div class="wall-result__body">
    <div class="wall-result__preloader" *ngIf="isFiltering()">
      <ui-preloader [color]="PreloaderColor.blue" [diameter]="40"></ui-preloader>
    </div>

    <ng-container *ngIf="!isFiltering()">
      <div class="wall-result__empty" *ngIf="walls().length === 0">
        {{
          (hasActiveFilters()
            ? 'SEARCH_GLOBAL_MODAL.WALL_RESULT.NO_WALLS_FILTERED'
            : 'SEARCH_GLOBAL_MODAL.WALL_RESULT.NO_WALLS'
          ) | translate
        }}
      </div>

      <div class="wall-row" *ngFor="let item of walls(); trackBy: trackByWallId">
        <div class="wall-row__summary" role="button" (click)="openWall(item)">
          <span class="wall-row__top">
            <span class="wall-row__name" [title]="item.name">{{ item.name }}</span>
            <span class="wall-row__type">{{ typeLabelKey(item) | translate }}</span>
          </span>
          <span class="wall-row__bottom">
            <span class="wall-row__tiles"
              >{{ item.tilesCount }}
              {{
                (item.tilesCount === 1
                  ? 'SEARCH_GLOBAL_MODAL.WALL_RESULT.TILE'
                  : 'SEARCH_GLOBAL_MODAL.WALL_RESULT.TILES'
                ) | translate
              }}</span
            >
            <span class="wall-row__date">{{ formatDate(item.createdAt) }}</span>
          </span>
        </div>

        <span class="wall-row__menu">
          <ui-preloader
            *ngIf="deletingWallId() === item._id || editingWallId() === item._id; else menuTrigger"
            [color]="PreloaderColor.gray"
            [diameter]="18"
          ></ui-preloader>
          <ng-template #menuTrigger>
            <span
              class="wall-row__menu-icon ui-icon-more-menu"
              [matMenuTriggerFor]="wallMenu"
              (click)="$event.stopPropagation()"
            ></span>
          </ng-template>
        </span>
        <mat-menu #wallMenu="matMenu" xPosition="before">
          <button mat-menu-item type="button" (click)="editWall(item)">
            {{ 'COMMON.EDIT' | translate }}
          </button>
          <button mat-menu-item type="button" (click)="deleteWall(item)">
            {{ 'SEARCH_GLOBAL_MODAL.WALL_RESULT.DELETE' | translate }}
          </button>
        </mat-menu>
      </div>
    </ng-container>
  </div>

  <div #sentinel class="wall-result__sentinel" aria-hidden="true"></div>

  <div class="wall-result__loading" *ngIf="isLoading()">
    {{ 'SEARCH_GLOBAL_MODAL.WALL_RESULT.LOADING' | translate }}
  </div>
</div>
